import { Link, useLocation } from "react-router-dom";

/**
 * Premium horizontal tab bar used to group related pages under a single
 * sidebar entry (Profil, Opportunités, Événements…).
 *
 * Each tab is a real React Router <Link> — no existing route is removed,
 * we simply expose them through a unified pill-style switcher.
 */
export default function SectionTabs({ tabs = [], eyebrow, title, subtitle, testid = "section-tabs" }) {
  const location = useLocation();

  const isActive = (to) => {
    if (to === location.pathname) return true;
    // Allow exact match for top-level OR explicit `match` predicate
    return false;
  };

  return (
    <div className="mb-8" data-testid={testid}>
      {(eyebrow || title) && (
        <div className="mb-6">
          {eyebrow && <p className="caption-label text-[#C68E59]">{eyebrow}</p>}
          {title && <h1 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] mt-1 leading-tight">{title}</h1>}
          {subtitle && <p className="text-sm text-[#8B8680] mt-2 max-w-2xl">{subtitle}</p>}
        </div>
      )}

      <div className="flex flex-wrap gap-2 border-b border-[#EADDC9] pb-3">
        {tabs.map((t) => {
          const active = t.match ? t.match(location.pathname) : isActive(t.to);
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`relative inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition ${
                active
                  ? "bg-[#1A1A1A] text-white shadow-sm"
                  : "text-[#6E4B2A] hover:bg-[#FAF3EA]"
              }`}
              data-testid={`tab-${t.id || t.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {t.icon && <t.icon className="w-3.5 h-3.5" />}
              {t.label}
              {t.count != null && t.count > 0 && (
                <span className={`ml-1 inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-[10px] font-semibold ${active ? "bg-[#D4A574] text-[#1A1A1A]" : "bg-[#C68E59] text-white"}`}>
                  {t.count}
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
